import * as React from 'react';
import * as _ from 'lodash';

import { CheckboxWithDisplayDisplayPart, ClickableDisplayPart, LinkButton } from 'consumer-components';
import { getOrganizationColors } from 'login-utils/deploymentConfig';

function textPartIsClickableDisplayPart(textPart: CheckboxWithDisplayDisplayPart): textPart is ClickableDisplayPart {
  return _.has(textPart, 'onClick') && _.has(textPart, 'display');
}

const organizationColors = getOrganizationColors();

namespace TextWithLinks {
  export interface Props {
    textParts: CheckboxWithDisplayDisplayPart[];
  }
}

class TextWithLinks extends React.PureComponent<TextWithLinks.Props> {
  render() {
    const { textParts } = this.props;
    return (
      <React.Fragment>
        {textParts.map((textPart, index) => {
          if (textPartIsClickableDisplayPart(textPart)) {
            return (
              <LinkButton
                color={organizationColors.action}
                onClick={textPart.onClick}
                key={`${textPart.display}-overviewLink`}
              >
                {textPart.display}
              </LinkButton>
            );
          }
          return <span key={`${textPart}-${index}`}>{textPart}</span>;
        })}
      </React.Fragment>
    );
  }
}

export default TextWithLinks;
